import * as React from 'react';
export const paycoSvg = React.forwardRef(function paycoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FA2828',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 13.644c0-.333.264-.597.598-.597H6.22c1.297 0 2.08.768 2.08 1.878v.016c0 1.258-.978 1.91-2.197 1.91h-.908v1.125a.593.593 0 0 1-.597.598.593.593 0 0 1-.598-.598v-4.332Zm2.143 2.143c.597 0 .947-.357.947-.823v-.016c0-.535-.373-.823-.97-.823h-.924v1.661h.947ZM8.11 17.76l1.895-4.279c.131-.295.373-.473.699-.473h.07c.326 0 .56.178.69.474l1.895 4.277a.585.585 0 0 1 .062.24.567.567 0 0 1-.566.575c-.28 0-.466-.162-.575-.41l-.365-.855h-2.39l-.381.893a.586.586 0 0 1-.551.372.55.55 0 0 1-.551-.559c0-.085.03-.17.069-.256Zm3.362-1.507-.753-1.794-.753 1.794h1.506Zm3.214.179-1.755-2.384a.704.704 0 0 1-.147-.427c0-.318.264-.574.598-.574.271 0 .442.147.59.364l1.32 1.902 1.343-1.917c.148-.218.327-.357.575-.357.365 0 .582.255.582.582a.75.75 0 0 1-.155.419l-1.755 2.368v1.568a.593.593 0 0 1-.597.598.593.593 0 0 1-.598-.598v-1.545h-.001Zm3.142-.606v-.016c0-1.545 1.164-2.81 2.833-2.81.815 0 1.366.217 1.817.551a.598.598 0 0 1 .232.473.583.583 0 0 1-.59.582.632.632 0 0 1-.357-.116c-.334-.248-.683-.388-1.11-.388-.916 0-1.576.761-1.576 1.692v.016c0 .932.644 1.707 1.576 1.707.504 0 .839-.155 1.18-.426a.56.56 0 0 1 .358-.132.56.56 0 0 1 .559.551.562.562 0 0 1-.202.427c-.49.427-1.064.683-1.933.683-1.6 0-2.787-1.233-2.787-2.794Zm5.233 0v-.016c0-1.545 1.219-2.81 2.896-2.81 1.676 0 2.88 1.25 2.88 2.795v.015c0 1.545-1.218 2.811-2.896 2.811-1.677 0-2.88-1.25-2.88-2.795Zm4.526 0v-.016c0-.931-.683-1.707-1.645-1.707s-1.63.76-1.63 1.692v.015c0 .932.683 1.708 1.645 1.708s1.63-.76 1.63-1.692Z',
      fill: '#fff',
    }),
  );
});
paycoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var payco = {
  category: 'brand',
  colorable: false,
  name: 'payco',
  svg: paycoSvg,
};
